import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Supplier } from '../../../../models/supplier.model';
import { EntityService } from '../../../../services/entity/entity.service';
import { SupplierService } from '../../../../services/supplier/supplier.service';

@Component({
  selector: 'app-supplier-form',
  templateUrl: './supplier-form.component.html',
  styles: ['label.required:after {top: 0}']
})

export class SupplierFormComponent implements OnInit {

  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: Supplier;

  addEditForm: FormGroup;
  show = {
    form:false
  }

  entity_items: {value: number, label: string}[];
  selected_entity: any;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    public supplierService: SupplierService,
    private svcEntities: EntityService) {
  }

  ngOnInit(): void {

    this.entity_items = [{value: null, label: ''}];

    this.supplierService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.svcEntities.getList().subscribe(res => {
      res.forEach(c => {
        this.entity_items.push({
          value: c.id,
          label: c.name
        })
      });
      this.show.form = true;
    });

    this.addEditForm = this.fb.group({
      'code': new FormControl(this.editingElement.code),
      'entity_id': new FormControl(this.editingElement.entity_id)
    });

  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.editingElement, this.addEditForm.value);
    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-list/supplier-form.component.ts